// Display labels for the `stage` string the backend writes on each job.
// Keep in sync with stages set in:
//   app/workers/runpod_dispatcher.py  (allocating_node, node_starting, retry)
//   runpod_worker/main.py             (download, preprocess, train, evaluate, upload, done, cancelled, failed)
//
// Never show a raw snake_case stage to users — fall back to a Title Case
// transform if a new stage shows up that we haven't mapped yet.

const STAGE_LABELS: Record<string, string> = {
  allocate: 'Allocating GPU node',
  allocating_node: 'Allocating GPU node',
  retry: 'Retrying',
  runpod_starting: 'Booting GPU node',
  node_starting: 'Booting GPU node',
  worker_booting: 'Worker starting',
  download: 'Downloading dataset',
  preprocess: 'Preprocessing',
  train: 'Training',
  evaluate: 'Evaluating',
  upload: 'Uploading artifacts',
  package: 'Packaging',
  shutdown: 'Releasing GPU node',
  done: 'Completed',
  cancelled: 'Cancelled',
  failed: 'Failed',
};

export function formatStage(stage: string | null | undefined, fallback = 'Preparing'): string {
  if (!stage) return fallback;
  if (STAGE_LABELS[stage]) return STAGE_LABELS[stage];
  // Unknown stage — title-case the snake_case so we never show raw tokens.
  return stage
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}
